export enum eventNames {
  homepage_exit_intent_trigger = 'Homepage Exit Intent - Trigger',
  homepage_exit_intent_selected = 'Homepage Exit Intent - Selected',
  homepage_exit_intent_clicked_cta = 'Homepage Exit Intent - Clicked CTA',
}
